// IMPORTS

// global
import { formatPrefixState } from "../../utils"
import { BANK_ASSET_ID, FIXED_15_SCALE_FACTOR } from "../../globals"

// local
import { STAKING_STRINGS } from "./stakingConfig"
import { UserRewardsProgramState } from "./rewardsProgramState"
import Staking from "./staking"

// INTERFACE

export default class UserStakingState {
  totalStaked: number
  scaledTotalStaked: number
  boostMultiplier: number
  rewardsBoost: number
  userRewardsProgramStates: { [key: number]: UserRewardsProgramState }
  
  totalUserAPR: number
  totalBankPerYear: number

  /**
   * Constructor for the user staking state object.
   * 
   * @param userLocalState - user's local state with one staking contract
   * @param staking - staking contract of interest
   */
  constructor(userLocalState: {}, staking: Staking) {
    this.totalStaked = userLocalState[STAKING_STRINGS.user_total_staked] || 0
    this.scaledTotalStaked = userLocalState[STAKING_STRINGS.user_scaled_total_staked] || 0
    this.boostMultiplier = userLocalState[STAKING_STRINGS.boost_multiplier] || 0
    this.rewardsBoost = Math.max(1, this.scaledTotalStaked / (0.4 * this.totalStaked))
    this.userRewardsProgramStates = {}
    const rewardsProgramCount = staking.rewardsProgramCount

    this.totalUserAPR = 0
    this.totalBankPerYear = 0
    for (let i = 0; i < rewardsProgramCount; ++i) {
      this.userRewardsProgramStates[i] = new UserRewardsProgramState(
        formatPrefixState(userLocalState),
        i,
        staking,
        this.scaledTotalStaked,
        this.rewardsBoost
      )
      if (staking.rewardsProgramStates[i].rewardsAssetId == BANK_ASSET_ID) {
        this.totalBankPerYear += this.userRewardsProgramStates[i].userRewardsPerDay.toDisplayAmount() * 365
      } else {
        this.totalUserAPR += this.userRewardsProgramStates[i].userAPR
      }
    }
  }
}
